export default __webpack_public_path__ + "static/media/Rule16.6df262cf.png";